import { FileWithPath } from "react-dropzone"

export function deriveFilePath(file: FileWithPath, baseFolder?: string): string | undefined {
    const rel = (file.path || "").replace(/^\/+/, "")
    const lastSlash = rel.lastIndexOf("/")
    const rawSubDir = lastSlash > 0 ? rel.slice(0, lastSlash) : ""
    const subDir = rawSubDir
        .split("/")
        .filter(seg => seg && seg !== "." && seg !== "..")
        .join("/")
    const combined = [baseFolder, subDir].filter(Boolean).join("/")
    return combined || undefined
}
